import { FC } from 'react';
import styled from 'styled-components';
import { colors, spacing, subtitle1 } from 'ui/theme';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';

export const Header = styled.header<{ navBarHeight: number }>`
  ${subtitle1}
  align-items: center;
  border-bottom: ${spacing.single} solid ${colors.grey15};
  color: ${colors.textSecondary};
  display: flex;
  flex: 0 0 ${({ navBarHeight }) => `${navBarHeight}px`};
  justify-content: space-between;
  min-height: ${({ navBarHeight }) => `${navBarHeight}px`};
  padding: ${spacing.half};
`;

export const DrawerHeader: FC<React.PropsWithChildren<unknown>> = (props) => {
  const navBarHeight = useNavBarHeight();
  return <Header navBarHeight={navBarHeight} {...props} />;
};
